// Pure, locale-independent date pieces for event cards (no RN imports, so it
// runs under `node --test`). Strings are built by hand — toLocale* output
// varies by device/ICU and made the cards inconsistent and untestable.
// Invalid input returns "" instead of throwing.
import { toDate } from "./eventHelpers.js";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const WEEKDAYS_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// "OCT"
export function monthShort(value) {
  const d = toDate(value);
  return d ? MONTHS[d.getMonth()].toUpperCase() : "";
}

// "12"
export function dayOfMonth(value) {
  const d = toDate(value);
  return d ? String(d.getDate()) : "";
}

// "Oct 6"
export function monthDay(value) {
  const d = toDate(value);
  return d ? `${MONTHS[d.getMonth()]} ${d.getDate()}` : "";
}

function clock(d) {
  const h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${h % 12 === 0 ? 12 : h % 12}:${m} ${h < 12 ? "AM" : "PM"}`;
}

// "7:45 PM"
export function timeLabel(value) {
  const d = toDate(value);
  return d ? clock(d) : "";
}

// "Tuesday, October 20, 2026"
export function longDate(value) {
  const d = toDate(value);
  return d ? `${WEEKDAYS_LONG[d.getDay()]}, ${MONTHS_LONG[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}` : "";
}

// "Today · 7:45 PM" on the same calendar day as `now`, else "Tue · 5:00 PM".
export function whenLabel(value, now = new Date()) {
  const d = toDate(value);
  if (!d) return "";
  const n = toDate(now) || new Date();
  const sameDay =
    d.getFullYear() === n.getFullYear() &&
    d.getMonth() === n.getMonth() &&
    d.getDate() === n.getDate();
  return `${sameDay ? "Today" : WEEKDAYS[d.getDay()]} · ${clock(d)}`;
}

// "October" / "October 2026"
export function monthTitle(value, withYear = false) {
  const d = toDate(value);
  if (!d) return "";
  return withYear ? `${MONTHS_LONG[d.getMonth()]} ${d.getFullYear()}` : MONTHS_LONG[d.getMonth()];
}

// "Mon, Oct 12"
export function dayLabel(value) {
  const d = toDate(value);
  return d ? `${WEEKDAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}` : "";
}

// "Mon, Oct 12 · 6:00 PM" (empty string when the event has no usable date)
export function formatEventWhen(event) {
  const d = toDate(event?.start_date);
  return d ? `${dayLabel(d)} · ${clock(d)}` : "";
}
